import { Markers } from "./markers";
import { HeatmapMarkerType, MarkerType } from "Common/types/elements/visualizer/marker";
import { HeatmapMarkerModel } from "./heatmapMarker"
import { MarkerEventCallback } from "Common/types/elements/visualizer/visualizerTypes";
import { InteractionManager } from "three.interactive";
import { Group, Scene } from "three";


class HeatmapMarkers extends Markers {
    constructor(markerList: Array<MarkerType>,
        markerEventCallback: MarkerEventCallback,
        interactionManager: InteractionManager,
        root: Group | Scene,
        selectedMarker: MarkerType,
        showAllMarkers?: boolean,
        group?: any) {
        super(markerList, markerEventCallback, interactionManager, root, selectedMarker, showAllMarkers, group)
    }

    createMarker(marker: HeatmapMarkerType): HeatmapMarkerModel {
        const markerModel = new HeatmapMarkerModel(marker, this.markerEventCallback, this.interactionManager)
        return markerModel
    }

    populateAllMarkers() {
        this.markerList.forEach((marker: HeatmapMarkerType) => {
            const markerModel = this.createMarker(marker)
            markerModel.setMaterial()
            this.group.add(markerModel.mesh)
        })
    }
}

export { HeatmapMarkers }